import { useContext } from 'react'
import { RuntimeConfigContext } from 'src/HOCs/withRuntimeConfigLoader'

export default function useRuntimeConfig() {
    return useContext(RuntimeConfigContext)
}
